import React from 'react';
import { StyleSheet, View } from 'react-native';
import Train from '../atoms/Train';

const styles = StyleSheet.create({
	container: {
		flex: 1,
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
	},
});

const Trains: React.VFC = () => {
	return (
		<View style={styles.container}>
			<Train />
			<Train />
			<Train />
			<Train />
			<Train />
			<Train />
			<Train />
			<Train />
			<Train />
		</View>
	);
};

export default Trains;
